<div>
  <ng-container *ngIf="withMainHeadline" class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Rechnungsstellung'" [icon]="'icon-invoice'" [iconToolTip]="'Rechnungsstellung'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>

  <ng-container *ngIf="!withMainHeadline">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <ng-template #table>
    <div class="body">
      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
          Rechnungsstellungliste
        </div>
        <div class="basis-1/2 flex flex-row justify-end items-center">
          <!-- <input pInputText type="text" class="p-inputtext p-component p-element mr-3"
            (input)="dtresources.filterGlobal($event.target?.['value'], 'contains')" placeholder="Ressource suchen" /> -->
        </div>
      </div>
      <div *ngIf="loadingService?.isLoadingSubject?.getValue()" class="spinner">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <div class="row flex basis-full gap-25 start pr-3 py-2 mt-2 items-center confirm" *ngIf="isIncreaseProcessing()">
        <div class="increaseProcessing flex basis-3/3 items-center">
          <i class="icon icon-attention hint"></i>
          Hinweis:&nbsp;<span class="darkgray">
            Eine Lizenzanpassung ist in Bearbeitung. Das kann einen Moment dauern...
          </span>
        </div>
      </div>
      <div class="row flex basis-full gap-25 start pr-3 py-2 mt-2 items-center confirm" *ngIf="isDecreaseProcessing() && !loadingService?.isLoadingSubject?.getValue()">
        <div class="increaseProcessing flex basis-3/3 items-center">
          <i class="icon icon-attention hint"></i>
          Hinweis:&nbsp;<span class="darkgray">
            Um eine Anpassung an deinen Lizenzen vorzunehmen, lösche bitte die vorgemerkte Lizenzanpassung etwas weiter unten oder <span class="deleteLicenceDecrease" (click)="deleteLicenceRequests()">hier</span>.
          </span>
        </div>
      </div>
      <div *ngIf="!loadingService?.isLoadingSubject?.getValue() && (!subscription || !subscription?.items || (subscription?.items && subscription?.items.length === 0)) " class="no-data">
        Keine Abrechnung verfügbar.
      </div>
      <div class="content" *ngIf="!loadingService?.isLoadingSubject?.getValue() && subscription  && (subscription?.items && subscription?.items.length > 0)">
        <div class="details flex flex-col basis-full pt-3" [ngClass]="isIncreaseProcessing() || isDecreaseProcessing() ? 'opacity':''">
          <div class="heading flex flex-row items-center">
            <h3>Lizenzen</h3>
            <span *ngIf="!isTrial()" class="darkgray">&nbsp;(Abrechnungsperiode: {{subscription?.startDateTime| date:'dd.MM.yyyy'}} - {{subscription?.endDateTime| date:'dd.MM.yyyy'}})</span>
            <span *ngIf="isTrial()" class="darkgray">&nbsp;(Kostenlose Testphase bis {{subscription?.trialEndDateTime| date:'dd.MM.yyyy'}})</span>
          </div>
          <div class="details-content">
            <div *ngIf="!subscription?.items || (subscription?.items && subscription?.items.length === 0) " class="no-data">
              Keine Lizenzen vorhanden.
            </div>
            <div *ngFor="let item of subscription?.items; index as j">
              <div class="row flex flex-row items-center basis-full border pr-3 pl-6 pt-2 pb-2">
                <div class="flex basis-1/3 justify-start">
                  <!-- <span><b>{{User.getLicenceType(item?.type?.toString())}}</b></span> -->
                  <span class="darkgray">&nbsp;(Zugewiesen: {{item?.assigned? item?.assigned: 0}})</span>
                </div>
                <div class="basis-1/3 flex items-center  justify-end">
                  <span>
                    <lib-increment-decrement-input [disabled]="isIncreaseProcessing() || isDecreaseProcessing()" [value]="+item?.quantity" [step]="1" [min]="0" (counterChange)="onCounterChange($event, j)" />
                  </span>&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>{{paymentService?.getCurrency(item?.price, item?.currency, currencyPipe)}}/{{paymentService?.getInterval(item?.interval)}}</span>
                  <!-- (counterChange)="quantities[j]=$event" -->
                </div>
                <div class="basis-1/3 flex flex-col place-items-end pr-4">
                  {{convertToEuro(getItemTotal(item, j))}}/{{getInterval(item)}}
                </div>
              </div>
              <div *ngIf="item?.discount" class="row-height flex flex-row items-center basis-full py-2 border pr-3 pl-6">
                <div class="flex basis-1/3 justify-start">
                  <span class="discount">Rabatt</span>
                  <span class="darkgray italic">&nbsp;({{item?.discount?.name}})</span>
                </div>
                <div class="basis-1/3 flex items-center justify-end">
                  <span>-{{getItemDiscount(item)}}</span>
                </div>
                <div class="basis-1/3 flex flex-col place-items-end pr-4">
                  <span>-{{convertToEuro(getItemDiscountValue(item, j))}}/{{getInterval(item)}}</span>
                </div>
              </div>
            </div>
            <div class="row-height flex basis-full gap-25 start justify-end place-items-end pr-3 py-2 border" *ngIf="subscription?.discount">
              <div class="flex basis-1/3 justify-start">
                <span class="discount">Sonderrabatt</span>
                <span class="darkgray italic">&nbsp;({{subscription?.discount?.name}})</span>
              </div>
              <div class="basis-1/3 flex items-center justify-end">
                <span>-{{getSubscriptionDiscount()}}</span>
              </div>
              <div class="basis-1/3 flex flex-col place-items-end pr-4">
                {{convertToEuro(getSubscriptionDiscountValue())}}/{{getInterval(subscription?.items[0])}}
              </div>
            </div>
            <div class="row-height flex basis-full gap-25 start justify-end place-items-end pr-3 py-2 border">
              <div class="flex basis-1/3 justify-start">
                <span><b>Gesamt</b></span>
                <span class="darkgray">&nbsp;(zzgl. Steuer)</span>
              </div>
              <div class="basis-1/3 flex items-center justify-end">
              </div>
              <div class="basis-1/3 flex flex-col place-items-end pr-4">
                <b>{{convertToEuro(getTotalWithDiscount())}}/{{getInterval(subscription?.items[0])}}</b>
              </div>
            </div>
            <div *ngIf="isTrial()" class="row-height flex basis-full gap-25 start justify-end place-items-end pr-3 py-2 border">
              <div class="flex basis-1/3 justify-start">
                <span><b>Kostenlose Testphase</b></span>
              </div>
              <div class="basis-1/3 flex items-center justify-end">
              </div>
              <div class="basis-1/3 flex flex-col place-items-end pr-4">
                <b>0,00€/{{getInterval(subscription?.items[0])}}</b>
              </div>
            </div>
            <div class="row flex basis-full gap-25 start pr-3 py-2 items-center confirm">
              <div class="flex basis-2/3 items-center">
                <ng-container *ngIf="isDecreasing()">
                  <i class="icon icon-attention hint"></i>
                  Hinweis:&nbsp;<span class="darkgray">
                    Die Reduzierungen von User-Lizenzen wird erst bei der nächsten Abrechnungsperiode berücksichtigt.
                  </span>
                </ng-container>
              </div>
              <div class="flex basis-1/3 justify-end place-items-end" *ngIf="!(isIncreaseProcessing() || isDecreaseProcessing())">
                <span><button mat-flat-button (click)="update()" id="save" color="primary" [disabled]="!checkChanged()">Bestätigen</button></span>
              </div>
              <div class="flex basis-1/3 justify-end place-items-end" *ngIf="isIncreaseProcessing() || isDecreaseProcessing()">
                <span><button mat-flat-button id="save" color="primary" [disabled]="true">In Bearbeitung</button></span>
              </div>
            </div>
          </div>
        </div>
        <div class="details flex flex-col basis-full pt-3" *ngIf="tenantLicenceRequests?.length >0">
          <div class="heading flex flex-row items-center">
            <div class="flex flex-row basis-2/3">
              <h3>Vorgemerkte Lizenzanpassungen</h3>
              <span class="darkgray small">&nbsp;(ab {{tenantLicenceRequests[0]?.paymentProviderFulfillmentDateTime |
                date:'dd.MM.yyyy'}})</span>
            </div>
            <div class="tools basis-1/3 flex justify-end">
              <app-nx-button icon="icon icon-trash" toolTip="Vorgemerkte Lizenzanpassungen löschen"
                (click)="deleteLicenceRequests()"></app-nx-button>
            </div>
          </div>
          <div class="details-content">
            <div *ngFor="let request of tenantLicenceRequests"
              class="row-height border flex flex-row items-center basis-full py-2 pr-3 pl-6">
              <div class="flex basis-1/2 justify-start">
                <!-- <span><b>{{User.getLicenceType(request?.licenceType.toString())}}</b></span> -->
              </div>
              <div class="flex basis-1/2 justify-end pr-3">
                <span>{{getRemainig(request)}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <lib-invoices [tenantId]="tenantId" /> -->
      </div>
    </div>
  </ng-template>
</div>

<ng-template #ErrorDialog>
  <span class="dialog-close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </span>
  <h2 mat-dialog-title>Fehler</h2>
  <mat-dialog-content class="flex flex-col">
    <div class="p-3">
      {{error}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button matDialogClose="no" color="primary">Schließen</button>
  </mat-dialog-actions>
</ng-template>


